//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wxConfig from '@/assets/js/wx_config'

export default {
  name: "deskDiaryMode",
  data(){
    return{
        bgImg:require('@/assets/images/activity/bg001@2x.png'),
        closeImg:require('@/assets/images/activity/close@2x.png'),
        btn1a:require('@/assets/images/activity/card01a@2x.png'),
        btn1b:require('@/assets/images/activity/card01b@2x.png'),
        btn2a:require('@/assets/images/activity/card02a@2x.png'),
        btn2b:require('@/assets/images/activity/card02b@2x.png'),
        signUpSuccess:require('@/assets/images/activity/image001@2x.png'),
        selType:1,
        userName:'',
        phone:'',
        verCode:'',
        firmName:'',
        num:'',
        codeTitle:'获取验证码',
        statusFlag:false,
        signUpShow:false,
        bgCodeColor:'#BB3720',
        codeColor:'#ffffff',
        borderColor:'#BB3720',
        submitFlag:false,
    }
  },
  mounted() {
        this.$store.commit('UPDATE_HEAD',false);
        this.$store.commit('UPDATE_FOOTER',false);
        this.$store.commit('UPDATE_PAGE_TITLE','小棉花台历新年团购');
        document.title = '小棉花台历新年团购'
        this.getSharedInfo()
  },
  methods:{
      
      close(){
          this.$emit("handleClose");
      },
      selectType(selectType){
          this.selType = selectType
      },
      successClick(){
        this.$router.go(-1)
      },
      signUp(){
        let self = this
        this.baseAjax({
            url:'/activity/enroll',
            showLoading:false,
            type:'post',
            data:{
                "activityEnroll":{
                    "intention":self.selType,
                    "userName":self.userName,
                    "userPhone":self.phone,
                    "corporateName":self.firmName,
                    "estimatedOrderQuantity":self.num,
                    "activityId":"aea297a735f141e030914b541604d5b5"
                }
            },
            success:function (data) {
                console.log(data)
                if(data.resultCode === 0){
                    self.$vux.loading.hide()
                    self.signUpShow = true
                }else{
                    self.$toast.text('报名失败');
                }
            }
        })
        
      },
      submit(){
          this.$vux.loading.show({
            text:'报名中',
          })
          this.submitFlag = true
          let self = this
          this.baseAjax({
            url:'/user/captcha/validate',
            showLoading:false,
            type:'post',
            data:{
                mode:'phone',
                phone:this.phone,
                event:'validate',
                captcha:self.verCode
            },
            success:function (data) {
                console.log(data)
                if(data.resultCode === 0){
                    self.signUp()
                }else{
                    self.$toast.text('验证码错误');
                }
            }
          })
      },
      getVerCode(){
        if(this.phone === ''){
            this.$toast.text('请输入手机号');
            return 
        }
        if(this.statusFlag){
            return
        }
        this.statusFlag = true
        let self = this
        this.baseAjax({
          url:'/user/captcha/get',
          showLoading:false,
          type:'post',
          data:{
            mode:'phone',
            phone:this.phone,
            event:'validate'
          },
          success:function (data) {
              console.log(data)
            if(data.resultCode === 0){
                self.$toast.text('验证码已发送');
                self.codeTitle = "60"
                self.bgCodeColor = 'transparent'
                self.codeColor = '#BB3720'
                self.borderColor = '#7D7D7D'
                let i = 0
                self.timer = setInterval(() => {
                    if(self.codeTitle === "1"){
                        clearInterval(self.timer)
                        self.codeTitle = '获取验证码'
                        self.statusFlag = false
                        self.bgCodeColor = '#BB3720'
                        self.codeColor = '#ffffff'
                        self.borderColor = '#BB3720'
                    }else{
                        i++
                        self.codeTitle = 60 - i + ''
                        self.bgCodeColor = 'transparent'
                        self.codeColor = '#BB3720'
                        self.borderColor = '#7D7D7D'
                    }
                },1000)
            }else{
                self.$toast.text('验证码发送失败');
            }
          }
        })
      },
      getSharedInfo(){
        let self = this;
        this.baseAjax({
            url:'/h5/getCard',
            showLoading:false,
            type:'post',
            data:{
                "type":"share_deskDiary",
                "returnType":"card",
            },
            success:function (data) {
                console.log(data)
                if(wxConfig.isWeiXin()){
                    let title = data.card.title
                    let desc = data.card.desc
                    let linkUrl = data.card.link
                    let imgUrl = data.card.imgUrl
                    wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl);
                }
            }
        })
      },
      isPhoneNumber(phone){
        var rv = 0;
        var mbphnoM = /^(13[4-9])|^(147)|^(150)|^(151)|^(152)|^(157)|^(158)|^(159)|^(178)|^(182)|^(183)|^(184)|^(187)|^(188)/;
        var mbphnoU = /^(130)|^(131)|^(132)|^(145)|^(155)|^(156)|^(175)|^(176)|^(185)|^(186)/;
        var mbphnoT = /^(133)|^(153)|^(177)|^(180)|^(181)|^(189)/;
        var mbphnoV =/^(170)/;

        var num11 = /^\d{11}$/; //11位数字;
        if (null != phone && "" != phone && num11.exec(phone)) {
            if (mbphnoM.exec(phone) || mbphnoU.exec(phone) || mbphnoT.exec(phone) || mbphnoV.exec(phone)) {
                rv = 0;
            }else {
                rv = 2;
            }
        } else {
            rv = 1;
        }
        return rv;
      }
  }
}



// WEBPACK FOOTER //
// ./src/components/share/component/deskDiaryMode.vue